/* global globalThis */
import React from 'react';
import { makeStyles, Box } from '@material-ui/core';
import '../CoursesList/coursesList.scss';
import { useTranslations } from 'sdk/custom-hooks';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { reactGaEvent } from 'sdk/actions/Common';
import PropTypes from 'prop-types';
import { ReactComponent as Live } from '../../../src/assets/images/live.svg';
import OverlayButton from '../../constants/OverlayButton';
import { useTheme } from '../../constants/themeProvider';
import DefaultCourseImage from '../../../src/assets/images/course-image.jpg';
import {
  setCourseId,
  setCourseName,
  setCourseProgress,
} from 'sdk/actions/getCourses';
import { ReactComponent as CertifiedIcon } from '../../../src/assets/images/certifiedIcon.svg';

function PackageCard(props) {
  const { testData, settingsData } = props;
  const history = useHistory();
  const t = useTranslations();
  const classes = useStyles();
  const theme = useTheme();
  const dispatch = useDispatch();

  function handleViewClick() {
    globalThis.dispatchEvent(new Event('storage'));
    reactGaEvent('Course Material', 'View Course');
    dispatch(setCourseName(testData?.name));
    dispatch(setCourseId(testData?._id));
    dispatch(setCourseProgress(testData?.progressPercent));
    history.push('/course-package');
  }

  const cardImage =
    testData?.featured || settingsData?.data?.[0]?.branding?.courseImage?.imagePath || DefaultCourseImage;

  return (
    <Box className="card-list-image">
      <Box className="image-container image-fix">
        <img
          className={classes.cardImage}
          style={{ borderRadius: '4px 4px 0px 0px' }}
          src={cardImage}
          alt=""
          onError={(event) => {
            event.target.onerror = null;
            event.target.src = DefaultCourseImage;
          }}
        />
        {testData?.isUserCourse && (
          <Box className={classes.courseBottomRight} style={{ background: theme?.primaryColor }}>
            <Box className="my-course-button">
              <span className="ribbon-text" style={{ color: theme?.primaryFontText }}>
                {t('MY_PACKAGE')}
              </span>
            </Box>
          </Box>
        )}
      </Box>

      <Box className="card-list">
        <Box className="course-module">
          {testData?.isSelfLearning === true ? (
            <button
              className="course-learning"
              style={{ border: `1px solid ${theme?.secondaryColor}`, color: theme?.secondaryColor }}
            >
              {t('SELF LEARNING')}
            </button>
          ) : (
            ''
          )}

          {testData?.isLive === true ? (
            <button
              className="course-live-learning"
              style={{ border: `1px solid ${theme?.secondaryColor}`, color: theme?.secondaryColor }}
            >
              <span className="live-image">
                <Live />
              </span>
              <span>{t('live')}</span>
            </button>
          ) : (
            ''
          )}

          <Box className="course-certificate-tag">
            <Box style={{ border: `1px solid ${theme?.secondaryColor}`, color: theme?.secondaryColor, display: 'flex', alignItems: 'center', gap: '4px' }} className="certificate-card-tag">
              <CertifiedIcon />
              {t('CERTIFICATE')}
            </Box>
          </Box>
        </Box>

        <p className="card-title">{testData?.name}</p>
        <Box className="card-description" dangerouslySetInnerHTML={{ __html: testData?.description }} />

        <Box className="free-div">
          <Box className="card-btn-new">
            <OverlayButton onClick={handleViewClick} title={t('VIEW_PACKAGE')} />
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

PackageCard.propTypes = {
  testData: PropTypes.shape({
    _id: PropTypes.string,
    name: PropTypes.string,
    progressPercent: PropTypes.number,
    featured: PropTypes.string,
    description: PropTypes.string,
    isUserCourse: PropTypes.bool,
    isSelfLearning: PropTypes.bool,
    isLive: PropTypes.bool,
  }).isRequired,
  settingsData: PropTypes.shape({
    data: PropTypes.array,
  }),
};

const useStyles = makeStyles(() => ({
  cardImage: {
    width: '100%',
    height: '100%',
    objectFit: 'contain !important',
  },
  courseBottomRight: {
    position: 'absolute',
    top: '17px',
    right: '-39px',
    textAlign: 'center',
    transform: 'rotate(45deg)',
    width: '139px',
    zIndex: '0',
  },
}));

export default PackageCard;
